import { Box, IconButton, Slider, Tooltip } from "@mui/material";
import { Water, Waves } from "@mui/icons-material";

export const EditorDAWWaveSpecSlider = ({ onChange, value }) => {
  const wavValue = (value || 0) * 100;

  const decreaseOpacity = () => {
    onChange(Math.max(0, (value || 0) - 0.1));
  };

  const increaseOpacity = () => {
    onChange(Math.min(1, (value || 0) + 0.1));
  };

  const handleChange = (v) => {
    if (v && v.target) {
      const newValue = v.target.value / 100;
      onChange(newValue);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1} width={1}>
      <Tooltip title="Decrease Opacity">
        <IconButton onClick={decreaseOpacity}>
          <Water color="primary" height={24} width={24} />
        </IconButton>
      </Tooltip>
      <Slider
        aria-label="Wave vs Spectrograph"
        max={100}
        min={0}
        size="small"
        step={1}
        value={wavValue}
        onChange={handleChange}
      />
      <Tooltip title="Increase Opacity">
        <IconButton onClick={increaseOpacity}>
          <Waves color="primary" height={24} width={24} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
